import { BannerResult, BillerResult, TokenRequest, TokenResult, TypeResult } from "../entities/Main";
import MainRepository from "../repositories/MainRepository";

export default class MainUseCase implements MainRepository {
  constructor(private repository: MainRepository) {
    this.repository = repository;
  }

  token(body: TokenRequest): Promise<TokenResult> {
    return this.repository.token(body);
  }
  getBiller(): Promise<BillerResult> {
    return this.repository.getBiller();
  }
  getListType(): Promise<TypeResult> {
    return this.repository.getListType();
  }
  getBannerPath(path: string): Promise<BannerResult> {
    return this.repository.getBannerPath(path);
  }
  getImagePath(path: string): Promise<any> {
    return this.repository.getImagePath(path);
  }

  getFaq(partnerId: string): Promise<any> {
    return this.repository.getFaq(partnerId);
  }
}
